class InputPostcode extends DummyElement {
  #input;
  #hint;

  constructor() {
    super();

    this.setAttribute("data-property", this.name);
    const shadow = this.attachShadow({ mode: "closed" });
    const container = document.createElement("div");
    container.classList.add("w-full", "my-15");
    const label = document.createElement("label");
    const span = document.createElement("span");
    span.innerText = this.label;
    const input = document.createElement("input");
    this.#input = input;
    this.#input.type = "number";
    this.#input.min = 10000;
    this.#input.max = 99999;
    this.#input.step = 1;
    input.classList.add("flex", "flex-wrap");

    label.appendChild(span);
    label.appendChild(input);
    container.appendChild(label);

    if (this.hint) {
      const hint = document.createElement("p");
      hint.classList.add("hint");
      hint.innerText = this.hint;
      this.#hint = hint;
      container.appendChild(hint);
    }

    shadow.appendChild(container);

    const style = document.createElement("style");
    style.textContent = this.#generateStyle();

    shadow.appendChild(style);

    this.#input.addEventListener("input", this.#handleInput.bind(this));
  }

  connectedCallback() {
    PriceRenderer.lock();
    if (localStorage.getItem("r-plz")) {
      this.#input.value = localStorage.getItem("r-plz");
      this.#validate();
    }
    PriceRenderer.instances.forEach((d) =>
      d.addEventListener("change", () => {
        this.#validate();
      })
    );
  }

  disconnectedCallback() {
    this.#input.removeEventListener("input", this.#handleInput);
  }

  get label() {
    return this.getAttribute("label");
  }

  get hint() {
    return this.getAttribute("hint");
  }

  get name() {
    return this.getAttribute("name");
  }

  #handleInput({ currentTarget }) {
    const regex = /\d{5}/;
    let m;

    if ((m = regex.exec(currentTarget.value)) !== null) {
      currentTarget.value = m[0];
      localStorage.setItem("r-plz", m[0]);
    }
    this.#validate();
  }

  #validate() {
    this.classList.remove("success");
    this.classList.remove("fail");
    const value = this.#input.value;
    if (
      value.length === 5 &&
      (
        value.startsWith("72") ||
        value.startsWith("75") ||
        value.startsWith("76") ||
        value.startsWith("77") ||
        value.startsWith("78") ||
        value.startsWith("79") ||
        value.startsWith("8") ||
        value.startsWith("93") ||
        value.startsWith("94"))
    ) {
      this.classList.add("success");

      if (PriceRenderer.valid) {
        PriceRenderer.release();
      }
      this.#hint.innerText = "Wir liefern an Ihre Postleitzahl.";
    } else {
      PriceRenderer.lock();

      this.#hint.innerText = this.hint;
      if (value.length === 5) {
        this.classList.add("fail");
        this.#hint.innerHTML =
          'Sie liegen außerhalb unseres Gebiets und können nicht durch uns beliefert werden. Bitte wenden Sie sich direkt an <a href="mailto:siegling@forbo.de">siegling@forbo.de</a>.';
      }
    }
  }

  #generateStyle() {
    return `
    :host(.success) input{
      border-color: green;
      outline-color: green;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwcHgiIGhlaWdodD0iMTAwcHgiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9ImdyZWVuIiBkPSJNOTEuMTk5IDMyLjMwMUw0NC4xMDEgNzkuMzk5Yy0zLjIgMy4yLTguNSAzLjItMTEuODAxIDBsLTIzLjUtMjMuNWMtMy4yLTMuMi0zLjItOC41IDAtMTEuODAxIDMuMi0zLjIgOC41LTMuMiAxMS44MDEgMEwzOC4zIDYxLjc5N2w0MS4xOTktNDEuMTk5YzMuMi0zLjIgOC41LTMuMiAxMS44MDEgMCAzLjA5OCAzLjIwMyAzLjA5OCA4LjUwNC0uMTAyIDExLjcwM3oiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==);
    }
    :host(.fail) input{
      border-color: #ff0f35;
      outline-color: #ff0f35;
      background-image: url(data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTggMTgiPjxwYXRoIGZpbGw9IiNmZjBmMzUiIGQ9Ik0xNSA0LjQxIDEzLjU5IDMgOSA3LjU5IDQuNDEgMyAzIDQuNDEgNy41OSA5IDMgMTMuNTkgNC40MSAxNSA5IDEwLjQxIDEzLjU5IDE1IDE1IDEzLjU5IDEwLjQxIDkgMTUgNC40MVoiPjwvcGF0aD48L3N2Zz4=);
    }
    :host(.success) .hint{
      color: green;
    }
    :host(.fail) .hint,
    :host(.fail) .hint a{
      color: #ff0f35;
    }
    * {
        box-sizing: border-box;
    }
    .w-full{
        width: 100%;
        position: relative;
    }
    .my-15 {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }
    .flex-wrap {
        flex-wrap: wrap;
    }
    .flex {
        display: flex;
    }
    input {
        display:block;
        appearance: none;
        background-color: #fff;
        border: 1px solid #c7c7c7;
        border-radius: 3px;
        cursor: pointer;
        line-height: 1.25;
        padding: 0.75rem 1.5rem;
        color: #22292f;
        width: 100%;
        padding: 0.75rem 1.5rem 0.75rem 1.3rem;
        font-size: 1.5rem;
        font-weight: 400;
        ${
          this.autocomplete
            ? `background-image: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMWwxLTEgOCA4IDgtOCAxIDEtOSA5eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+);`
            : ""
        }
        background-position: right 1em center;
        background-size: 1em;
        background-repeat: no-repeat;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type=number] {
      -moz-appearance: textfield;
    }
    label  {
        display: block;
        font-weight: 500;
        margin-top: 0;
        position: relative;
        color: #101010;
        font-size: 1.3rem;
    }
    label span {
        display:block;
        margin-bottom: 0.5rem;
    }
    .hint {
      color: #909090;
      font-size: 1.1rem;
      line-height: 1.4;
      margin: .5rem 0 1rem;
    }
    `;
  }
}

customElements.define("input-postcode", InputPostcode);
